import PropTypes from 'prop-types';

import SubjectUDCCard from 'uI/SubjectUDCCard/SubjectUDCCard';

import classes from './ArchiveClasses.module.css';

const ArchiveClasses = props => {
  return (
    <div className={classes.udcClassessContainer}>
      <p className={classes.mySubjectsTitleSpecial}>
        Mis materias archivadas
      </p>
      <div className={classes.cardsContainer}>
        {props.classrooms.coursesStudent.filter(items => {
          return items.courseState === 'ARCHIVED';
        }).length > 0 && (
          <>
            {props.classrooms.coursesStudent.map(classroom => (
              <SubjectUDCCard
                key={classroom.id}
                classroomData={classroom}
                archived
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

ArchiveClasses.propTypes = {
  // eslint-disable-next-line react/require-default-props
  status: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  classrooms: PropTypes.array
};

export default ArchiveClasses;
